const createAction = ({ type, ...data }) => ({ type, ...data });

export { createAction };
